import React from "react";
import styles from "./DuaSkeleton.module.scss";

const DuaPageSkeleton: React.FC = () => {
  return (
    <div className={styles.duaPage}>
      <h1 className={styles.skeletonHeader}></h1>
      <hr />
      <div className={styles.duaList}>
        {[...Array(4)].map((_, index) => (
          <div key={index} className={styles.duaCard}>
            <div className={styles.duaCardImage}></div>
            <div className={styles.cardHeader}></div>
            <div className={styles.cardBody}>
              <div className={styles.textContent}>
                <div className={styles.skeletonText}></div>
                <div className={styles.skeletonText}></div>
                <div className={styles.skeletonText}></div>
              </div>
              <div className={styles.audioPlayer}>
                <div className={styles.playButton}></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DuaPageSkeleton;
